import * as T from '../constants/types';

const initialState = [];

export const displayedLayers = (state = initialState, { type, payload }) => {
    switch (type) {
        case T.TOGGLE_LAYER:
            return payload;
        default:
            return state;
    }
};
